import RentalsApiClient from './RentalsApiClient';

export * from './rentals-api';
export * from './rentals-api/models';

export default RentalsApiClient;
